/**
 * Convert a click point (CSS pixels, as given by Mapbox GL's `event.point`) into the
 * canvas drawing-buffer's DEVICE-pixel space, so a WMS GetFeatureInfo I/J matches the
 * WIDTH/HEIGHT taken from `canvas.width`/`canvas.height` (#652).
 *
 * Mapbox GL scales the drawing buffer by the device pixel ratio, so on a HiDPI/Retina
 * display `canvas.width` (device px) is larger than `canvas.clientWidth` (CSS px). Sending
 * the click in CSS px against device-px dimensions makes GeoServer resolve the query to the
 * wrong point → empty/wrong results. The reconciling factor is the canvas's own ratio
 * (`width / clientWidth`), which is more robust than `window.devicePixelRatio` because
 * Mapbox may cap its internal pixel ratio.
 */

export interface CanvasPixelDims {
  width: number;        // canvas.width — device pixels
  height: number;       // canvas.height — device pixels
  clientWidth: number;  // canvas.clientWidth — CSS pixels
  clientHeight: number; // canvas.clientHeight — CSS pixels
}

export function clickToDevicePixels(
  point: { x: number; y: number },
  canvas: CanvasPixelDims,
): { i: number; j: number } {
  const sx = canvas.clientWidth > 0 ? canvas.width / canvas.clientWidth : 1;
  const sy = canvas.clientHeight > 0 ? canvas.height / canvas.clientHeight : 1;
  return {
    i: Math.round(point.x * sx),
    j: Math.round(point.y * sy),
  };
}
